import { Card as AntDesignCard, Col, Grid, Row } from "antd";
import { useMemo, useState } from "react";
import { DevCardObject } from "../../classesAndInterfaces/DevCard";
import style from "./DevCard.module.less";
import "./DevCard.less";
import Modal from "antd/lib/modal/Modal";

interface PropsFromSkillCards {
  /**
   *  @description openDrawer - function for trigerring any
   *  action when user click on description
   */
  openDrawer: Function;
}

const DevCard = ({
  title,
  description,
  image_url,
  techonologiesAndTools,
  openDrawer,
}: DevCardObject & PropsFromSkillCards) => {
  const [showCase, setShowCase] = useState(false);
  const { useBreakpoint } = Grid;
  const breakpoints = useBreakpoint();

  /**
   * @memorized value for modal width according to screen
   */
  const width: string = useMemo(() => {
    const screens = Object.entries(breakpoints).filter((screen) => !!screen[1]);
    const screen_size = screens[screens.length - 1]?.[0];
    switch (screen_size) {
      case "xl":
        return "46vw";
      case "lg":
        return "82vw";
      case "md":
        return "75vw";
      case "sm":
        return "100%";
      case "xs":
        return "100%";
      default:
        return "40vw";
    }
  }, [breakpoints]);

  const showModal = () => {
    setShowCase(true);
  };
  const closeModal = () => {
    setShowCase(false);
  };

  /**
   * @description Makes the UI from the DevCard object
   * @returns JSX.Element
   */
  const Contents = ({modal} : {modal? :boolean}): JSX.Element => {
    return (
      <div className={style.wrapper_div}>
        <AntDesignCard
          hoverable={true}
          className={style.card_style}
          onClick={() => showModal()}
          cover={
            <img alt="technology" src={image_url} className={style.card_cover} />
          }
        >
          <Row
            justify="start"
            align="top"
            className={[
              style.card_contents,
              modal ? style.showcased : style.card_row,
            ].join(" ")}
          >
            <Col span={24}>
              <h1>{title.toLocaleUpperCase()}</h1>
            </Col>
            <Col span={24}>
              <Row
                className={
                  modal
                    ? style.card_description
                    : style.card_description_overview
                }
              >
                <Col span={24}>
                  <p onClick={() => openDrawer()}>{description}</p>
                </Col>
                {modal && (
                  <Col span={24}>
                    <p className={style.technologiesAndTools}>
                      {techonologiesAndTools?.map((item, index) => {
                        if (index !== techonologiesAndTools?.length - 1) {
                          return item + ", ";
                        }
                        return item;
                      })}
                    </p>
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </AntDesignCard>
      </div>
    );
  };

  return (
    <>
      <Modal
        visible={showCase}
        centered
        footer={null}
        onCancel={() => closeModal()}
        width={width}
        className={style.modal_content}
      >
        <Contents modal={true} />
      </Modal>
      <div className={!showCase? style.visible : style.invisible}>
        <Contents />
      </div>
    </>
  );
};

export default DevCard;
